import { render, staticRenderFns } from "./AddVenue.vue?vue&type=template&id=b682cab8&"
import script from "./AddVenue.vue?vue&type=script&lang=js&"
export * from "./AddVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports